"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.HelpText = void 0;
var PropTypes = require("prop-types");
var React = require("react");
var HelpText = function (props) {
    if (typeof props.children === 'string') {
        return (React.createElement("p", { id: props.id + "-helptext", className: "form-text" }, props.children));
    }
    return (React.createElement("div", { id: props.id + "-helptext", className: "form-text" }, props.children));
};
exports.HelpText = HelpText;
exports.HelpText.propTypes = {
    children: PropTypes.any.isRequired,
    id: PropTypes.string.isRequired,
};
